import { render, staticRenderFns } from "./packages_list_loader.vue.js?vue&type=template&id=e63cc612!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./packages_list_loader.vue?vue&type=template&id=e63cc612"
import script from "./packages_list_loader.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./packages_list_loader.vue?vue&type=script&lang=js"
export * from "./packages_list_loader.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./packages_list_loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports